export default __webpack_public_path__ + "static/media/Circles1.715d9377.png";